import React, { useEffect, useState } from 'react';
import { EventItem } from './index';

const EventsList = ({ dataFromMeetup }) => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    today = yyyy + '-' + mm + '-' + dd;

    const filteredEvent = dataFromMeetup
      .filter((e) => {
        return e.date_en >= today;
      })
      .slice(0, 3);
    setEvents(filteredEvent);
  }, [dataFromMeetup]);

  return (
    <div css={{ paddingTop: 16 }}>
      {events.map((event) => {
        event.venue = event.venue || {};
        return (
          <EventItem
            key={event._id}
            date={event.date_en}
            startTime={event.time_24}
            duration={event.duration_in_hours}
            place={event.venue.name}
            address={event.venue.address_1}
            city={event.venue.city}
            title={event.event_type}
            event={event}
            isOnline={event.isOnline}
          />
        );
      })}
    </div>
  );
};

export default EventsList;
